module.exports = __webpack_public_path__ + "img/info-bg.4880692f.png";